const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const cartWrapper = tryonTemplateContainer?.querySelector(".to__add-to-cart");
if (!cartWrapper) return;

const overlay = cartWrapper?.querySelector(".to__catalogue--overlay");
const atcCloseBtn = cartWrapper?.querySelector(".to__atc__close");
const cartButton = cartWrapper?.querySelector(".to__add-to-cart button");
const addToCartLoader = tryonTemplateContainer?.querySelector(".to__add-to-cart .loader");
const form = cartWrapper?.querySelector("#try-on-prod-form");
const formVariantId = cartWrapper?.querySelector("[data-product-select]");
const formProductId = cartWrapper?.querySelector('[name="product-id"]');

function updateUI() {
  let selectedFrame = tryonTemplateContainer?.querySelector(".selected-frame + [data-json]");
  if (!selectedFrame) {
    selectedFrame = tryonTemplateContainer?.querySelector(".selected-frame [data-json]");
  }
  if (!selectedFrame) return;

  const productData = JSON.parse(selectedFrame.dataset.json);
  if (!productData) return;

  updateInfo(productData);
  updateStrengthOptions(productData);
  updateLensesOptions(productData);
  updateGrid(selectedFrame, productData);
  updateSubmitButtonState();
}

function updateGrid(selectedFrame, newProductData) {
  const frameWrapper = selectedFrame.closest(".to-glasses-wrapper");
  const imgEl = frameWrapper?.querySelector(".to-image");
  const titleEl = frameWrapper?.querySelector(".to-title");
  const priceEl = frameWrapper?.querySelector(".to-price");
  const defaultConnectedProd = frameWrapper?.querySelector(".to-default-cp");

  if (titleEl.innerHTML.trim() == newProductData.productTitle.trim()) return;
  if (imgEl && newProductData.productImage) imgEl.innerHTML = newProductData.productImage;
  if (titleEl && newProductData.productTitle) titleEl.innerHTML = newProductData.productTitle;
  if (priceEl && newProductData.productPrice) priceEl.innerHTML = newProductData.productPrice;
  if (defaultConnectedProd) {
    defaultConnectedProd.classList.remove("to-default-cp");
    selectedFrame?.previousElementSibling.classList.add("to-default-cp");
  }
}

function updateSubmitButtonState() {
  const submitButton = tryonTemplateContainer?.querySelector(".submit-try-on-atc");
  if (!submitButton) return;

  const isExpanded = cartWrapper?.classList.contains("expanded");
  const isVariantAvailable = checkSelectedVariantAvailability();
  const labelSpan = submitButton.querySelector(".label");

  // Get text from data attributes
  const addToCartText = submitButton.dataset.addToCartText;
  const soldOutText = submitButton.dataset.soldOutText;

  // Disable button and update label if cart is expanded and variant is not available
  if (isExpanded && !isVariantAvailable) {
    submitButton.disabled = true;
    if (labelSpan && soldOutText) {
      labelSpan.textContent = soldOutText;
    }
  } else {
    submitButton.disabled = false;
    if (labelSpan && addToCartText) {
      labelSpan.textContent = addToCartText;
    }
  }
}

function checkSelectedVariantAvailability() {
  const strengthInputOptions = cartWrapper?.querySelectorAll(".to__atc_option-strength input.radio_input");
  const hasStrengthOptions = strengthInputOptions && strengthInputOptions.length > 0;

  // Check if any strength option is selected and available
  const selectedStrengthOption = cartWrapper?.querySelector(".to__atc_option-strength input.radio_input:checked");
  if (selectedStrengthOption) {
    const correspondingLabel = cartWrapper?.querySelector(`.to__atc_option-strength label[for="${selectedStrengthOption.id}"]`);
    return correspondingLabel && !correspondingLabel.classList.contains("not-available");
  }

  // For products with strength variants, force an explicit available selection.
  if (hasStrengthOptions) return false;

  return true;
}

function updateInfo(newProductData) {
  const imgEl = cartWrapper?.querySelector(".to-image");
  const typeEl = cartWrapper?.querySelector(".to__atc__type");
  const titleEl = cartWrapper?.querySelector(".to__atc__title");
  const priceEl = cartWrapper?.querySelector(".to__atc__price");

  if (imgEl && newProductData.productImage) imgEl.innerHTML = newProductData.productImage;
  if (typeEl && newProductData.type) typeEl.innerHTML = newProductData.type;
  if (titleEl && newProductData.productTitle) titleEl.innerHTML = newProductData.productTitle;
  if (priceEl && newProductData.productPrice) priceEl.innerHTML = newProductData.productPrice;
}

function updateStrengthOptions(newProductData) {
  const strengthContainerEl = cartWrapper?.querySelector(".to__atc_option-strength");

  if (strengthContainerEl && newProductData.productStrengthOptions) {
    const options = newProductData.productStrengthOptions;
    const optionName = "Strength";
    const strengthOptionsEl = strengthContainerEl.querySelector(".to_atc__options");
    const optionsWrapper = document.createElement("div");
    optionsWrapper.classList.add("to_atc__options");

    formVariantId.value = "";

    options.forEach((option, index) => {
      const id = `--${optionName}-${index}`;
      const radioButton = document.createElement("input");
      radioButton.type = "radio";
      radioButton.classList.add("radio_input");
      radioButton.name = `options[${optionName}]`;
      radioButton.id = id;
      radioButton.value = option.valueName;

      const label = document.createElement("label");
      label.classList.add("to__atc__option");
      label.htmlFor = id;
      label.textContent = option.valueName;
      label.setAttribute("data-variant-id", option.variantId);

      if (!option.available) {
        radioButton.disabled = true;
        label.classList.add("not-available");
      }

      if (newProductData.currentValue?.trim() === option.valueName?.trim()) {
        radioButton.setAttribute("checked", true);
        formVariantId.value = option.variantId;
      }

      optionsWrapper?.append(radioButton);
      optionsWrapper?.append(label);
    });

    formProductId.value = newProductData.id;

    strengthOptionsEl.innerHTML = optionsWrapper.innerHTML;
    strengthContainerEl.classList.add("has-strength");
    setStrengthEvents(strengthOptionsEl);
  } else if (strengthContainerEl) {
    strengthContainerEl.classList.remove("has-strength");
  }
}

function updateLensesOptions(newProductData) {
  const lensesContainerEl = cartWrapper?.querySelector(".to__atc_option-lenses");

  const typeOptions = newProductData.productTypeOptions;
  if (typeOptions && lensesContainerEl) {
    const lensesOptionsEl = lensesContainerEl.querySelector(".to_atc__options");
    const newOptionsWrapper = document.createElement("div");
    const currentType = newProductData.type;
    const typesMap = new Map();

    const opticalType = typeOptions.find((option) => option.type === "Reading glasses" && option.frameId);
    if (opticalType) typesMap.set("Optical", opticalType);
    const blueLightType = typeOptions.find((option) => option.type === "Blue light glasses" && option.frameId);
    if (blueLightType) typesMap.set("Blue light", blueLightType);
    const sunglassesType = typeOptions.find((option) => option.type === "Sunglasses" && option.frameId);
    if (sunglassesType) typesMap.set("Sun", sunglassesType);

    typesMap.set(currentType, { ...newProductData, current: true });

    const types = Object.fromEntries(Array.from(typesMap));

    let index = 0;
    for (const type in types) {
      if (Object.prototype.hasOwnProperty.call(types, type)) {
        const id = `--Lenses-${index}`;
        const radioButton = document.createElement("input");
        radioButton.type = "radio";
        radioButton.classList.add("radio_input");
        radioButton.name = `options[Lenses]`;
        radioButton.id = id;
        radioButton.value = type;

        const label = document.createElement("label");
        label.classList.add("to__atc__option");
        label.htmlFor = id;
        label.textContent = type;
        label.setAttribute("data-product-id", types[type].id);
        label.setAttribute("data-frame-id", types[type].frameId);
        label.setAttribute("data-product-type", types[type].type);
        index++;

        if (types[type].current) radioButton.setAttribute("checked", true);

        if (type == "Reading glasses") {
          newOptionsWrapper?.prepend(label);
          newOptionsWrapper?.prepend(radioButton);
        } else {
          newOptionsWrapper?.append(radioButton);
          newOptionsWrapper?.append(label);
        }
      }
    }

    lensesOptionsEl.innerHTML = newOptionsWrapper.innerHTML;
    lensesContainerEl.classList.add("has-lenses");

    setLensesEvents(lensesContainerEl, types);
  } else if (lensesContainerEl) {
    lensesContainerEl.classList.remove("has-lenses");
  }
}

function setStrengthEvents(container) {
  const strengthOptions = container.querySelectorAll(".to__atc__option:not(.not-available)");

  strengthOptions?.forEach((option) => {
    const variantId = option.dataset.variantId;

    option.addEventListener("click", () => {
      formVariantId.value = variantId;
      updateSubmitButtonState();
    });
  });
}

function setLensesEvents(lensesContainerEl, types) {
  const lensesOptions = lensesContainerEl?.querySelectorAll(".to__atc__option");

  lensesOptions?.forEach((lense) => {
    const productType = lense.dataset.productType;
    const frameId = lense.dataset.frameId;
    const newProductData = Object.values(types).find((option) => option.type == productType);

    lense.addEventListener("click", () => {
      updateInfo(newProductData);
      updateStrengthOptions(newProductData);
      updateSubmitButtonState();
      if (frameId && fitmixInstance) fitmixInstance?.setFrame(frameId);
    });
  });
}

function initQuantity() {
  const decrementBtn = cartWrapper.querySelector(".to__atc__quantity .decrement");
  const incrementBtn = cartWrapper.querySelector(".to__atc__quantity .increment");
  const quantityDisplay = cartWrapper.querySelector(".to__atc__quantity .quantity");
  const quantityInput = cartWrapper.querySelector('[name="quantity"]');

  let quantity = quantityDisplay ? parseInt(quantityDisplay.textContent, 10) : 1;

  decrementBtn?.addEventListener("click", () => {
    if (quantity > 1) {
      quantity--;
      quantityDisplay.textContent = quantity;
      quantityInput.value = quantity;
    }
  });

  incrementBtn?.addEventListener("click", () => {
    quantity++;
    quantityDisplay.textContent = quantity;
    quantityInput.value = quantity;
  });
}

cartButton?.addEventListener("click", (e) => {
  if (!cartWrapper?.classList.contains("expanded")) {
    setTimeout(() => {
      cartWrapper?.classList.add("expanded");
      updateSubmitButtonState();
    }, 0);
  } else {
    e.preventDefault();
  }
});

[overlay, atcCloseBtn].forEach((el) => {
  el?.addEventListener("click", () => {
    cartWrapper?.classList.remove("expanded");
    updateSubmitButtonState();
  });
});

document.addEventListener("try-on:frame-selected", updateUI);

initQuantity();

form?.addEventListener("submit", (e) => {
  e.preventDefault();
});

// Initialize button state
updateSubmitButtonState();
